<script lang="ts">
    import type {Fond} from 'typings/portaro.be.types';
    import {createEventDispatcher} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import SearchToolbarSection from './SearchToolbarSection.svelte';
    import KpDropdownMenuWrapper from 'shared/ui-widgets/dropdown-menu/KpDropdownMenuWrapper.svelte';
    import KpDropdownMenuItem from 'shared/ui-widgets/dropdown-menu/KpDropdownMenuItem.svelte';

    export let fond: Fond;
    export let relatedFonds: Fond[] | null;

    const dispatch = createEventDispatcher<{'fond-change': Fond}>();
</script>

<SearchToolbarSection additionalClasses="search-toolbar-fond-selector"
                      icon="grid-alt"
                      title="Pohled">

    {#if exists(relatedFonds)}
        <KpDropdownMenuWrapper>
            <span class="font-name" slot="button">{fond.text}</span>

            <svelte:fragment slot="menu">
                {#each relatedFonds ?? [fond] as relatedFond}
                    <KpDropdownMenuItem on:click={() => dispatch('fond-change', relatedFond)}>
                        {relatedFond.text}
                    </KpDropdownMenuItem>
                {/each}
            </svelte:fragment>
        </KpDropdownMenuWrapper>
    {:else}
        <span class="font-name">{fond.text}</span>
    {/if}
</SearchToolbarSection>